// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"VirtualListWithKeyboard_menuContainer__3HLcJ","menuItem":"VirtualListWithKeyboard_menuItem__19-wX","empty":"VirtualListWithKeyboard_empty__1It9P"};